let fields = [
  {
    key: 'date',
    label: 'report.fields.date',
    header: 'date',
    filter: false,
    width: 20,
  },
  {
    key: 'day',
    label: 'report.fields.day',
    header: 'day',
    filter: false,
    width: 30,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 20,
  },
  {
    key: 'imei',
    label: 'report.fields.imei',
    header: 'imei',
    filter: false,
    width: 30,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: false,
    width: 20,
  },
  {
    key: 'totalWorkingHours',
    label: 'report.fields.totalWork',
    header: 'totalWorkingHours',
    filter: false,
    width: 30,
  },
  {
    key: 'lastEngineOn',
    label: 'report.fields.lastEngine',
    header: 'lastEngineOn',
    filter: false,
    width: 30,
  },
]
export default fields
